import type { EntityConfig } from "../hooks/useEntity";

export const scratchPadEntityConfig: EntityConfig = {
  name: "ScratchPad",
  orderBy: "created_at DESC",
  properties: {
    documentId: { type: "integer", description: "Associated document ID" },
    userId: { type: "integer", description: "Owner user ID" },
    title: { type: "string", description: "Scratch pad entry title" },
    content: { type: "string", description: "Saved text content" },
    tags: { type: "string", description: "JSON array of tags for organization" },
    position: { type: "number", description: "Ordering index for display" },
  },
  required: ["documentId", "userId", "content"],
};
